module.exports = __webpack_public_path__ + "img/rd-laboratory-rounded.c5cb646a.png";